import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ArrowLeft = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m10.06 18.708-6.06-6m0 0 6.06-6m-6.06 6h16'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M9.59 6.124a.75.75 0 0 1 1.05 1.06l-.052.057-4.765 4.717H20l.077.004a.75.75 0 0 1 0 1.492l-.077.004H5.823l4.765 4.717.052.056a.75.75 0 0 1-1.05 1.06l-.057-.05-6.06-6a.75.75 0 0 1 0-1.066l6.06-6z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
